import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un producto físico?',
    a: 'No. Es una guía digital en PDF.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Después de tu compra, recibes acceso inmediato para descargarlo.'
  }, {
    q: '¿Está en español?',
    a: 'Sí, completamente en español.'
  }, {
    q: '¿Tengo que pasar hambre?',
    a: 'No. La guía está diseñada para seguir un plan simple, no para que dejes de comer.'
  }, {
    q: '¿Necesito suplementos caros?',
    a: 'No. El enfoque está pensado para ser práctico y fácil de seguir.'
  }, {
    q: '¿Puedo hacerlo si trabajo todo el día?',
    a: 'Sí. Está hecho para mujeres con poco tiempo.'
  }, {
    q: '¿Puedo verlo desde mi celular?',
    a: 'Sí. Puedes abrirlo desde tu celular, tablet o computadora.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas una sola vez y recibes acceso inmediato.'
  }];
  return <Section className="bg-cream" data-id="element-22">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-10 text-center" data-id="element-23">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-24">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-25" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-sage rounded-xl overflow-hidden shadow-sm" data-id="element-26">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-27">
        <span className="font-serif font-bold text-forest text-lg" data-id="element-28">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-forest transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-29" />
      </button>
      <AnimatePresence data-id="element-30">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-31">
            <div className="px-6 pb-4 text-gray-600" data-id="element-32">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}